/** Strings of the catalog pages. */
export const ca_catalog = {
  terrainPage: {
    back: 'Catàleg',
    open: (name: string) => `Obre el detall de ${name}`,
    notSurveyed:
      'Aquest terreny encara no s’ha inspeccionat: del terra (ponts, platges, llocs plans, posicions militars) no se’n sap res. Es fa des del catàleg.',
    surveyState: (state: string) => `La inspecció d’aquest terreny no ha acabat (${state}).`,
    surveyRunning:
      'Inspecció en curs: es mostren les dades de l’última inspecció acabada fins que aquesta acabi.',
    oldSurvey: (have: number, want: number) =>
      `Dades d’una inspecció antiga: és de la versió ${have} i la plataforma ara en fa la ${want}.`,
    resurveyAsked: 'Inspecció demanada: aquesta pàgina ensenyarà les dades noves quan acabi.',
    resurveyFailed: 'No s’ha pogut demanar la inspecció.',
    figuresLabel: 'Xifres del terreny',
    figures: {
      land: 'Terra ferma',
      highest: 'Punt més alt',
      mean: 'Alçada mitjana',
      buildings: 'Edificis',
      transmitters: 'Antenes',
      runways: 'Pistes mesurades',
    },
    landValue: (km2: string, percent: number) => `${km2} km² · ${percent} %`,
    metres: (m: string) => `${m} m`,
    origin: (mod: string) => `Mod d’origen: ${mod}`,
    surveyVersion: (have: number, want: number) => `versió ${have} de ${want}`,
    layerCapped: (shown: number, total: string) => `${shown} de ${total}`,
    layerSample: (shown: number) => `els ${shown} més destacats`,
    runwaysTitle: 'Pistes mesurades per la inspecció',
    runwayNames: {
      main: 'Pista principal',
      secondary: 'Pista secundària',
      dynamic: 'Pista',
    } as Record<string, string>,
    colTakeoff: 'Rumb d’enlairament',
    colLength: 'Longitud',
    colSurface: 'Ferm',
    paved: 'Pavimentada',
    unpaved: 'Terra',
    bridgesTitle: 'Ponts',
    colSpan: 'Llargada',
    colOver: 'A sota',
    overWater: 'Aigua',
    overLand: 'Terra',
    colDrop: 'Alçada del tauler',
    massesTitle: 'Masses de terra',
    colArea: 'Superfície',
    km2: (v: string) => `${v} km²`,
    notScanned:
      'Cap conjunt de mods escanejat porta aquest terreny: no se’n coneixen els llocs amb nom ni els aeròdroms.',
    layersLabel: 'Capes del mapa',
    layers: {
      settlements: 'Poblacions',
      places: 'Altres llocs amb nom',
      airfields: 'Pistes i aeròdroms',
      sites: 'Posicions militars',
      bridges: 'Ponts',
      highGround: 'Punts elevats',
      flatAreas: 'Llocs plans',
      beaches: 'Platges',
      lakes: 'Llacs',
    },
    landMasses: 'Masses de terra',
    surveyedOn: (when: string) => `Inspeccionat el ${when}`,
    gridStep: (m: number) => `una mostra cada ${m} m`,
    capped: (n: number) =>
      `La inspecció desa els ${n} punts més destacats de cada capa, i al mapa no se’n dibuixen més de ${n} per capa.`,
    noSize: 'No es coneix la mida d’aquest terreny i no es pot dibuixar.',
    mapHint:
      'Roda o pessic per fer zoom i arrossega per moure’t. Els noms surten en acostar-se o en triar un punt de les taules.',
    placesTitle: 'Llocs amb nom',
    colName: 'Nom',
    colType: 'Tipus',
    colGrid: 'Quadrícula',
    colRadius: 'Radi',
    showAll: (n: number) => `Mostra’ls tots (${n})`,
    showFewer: 'Mostra’n menys',
    colHeading: 'Rumb d’aproximació',
    colObjects: 'Objectes',
    colKinds: 'Què hi ha',
    sitesHint:
      'Agrupacions d’objectes militars del mapa: el generador hi posa bases enemigues, objectius i, si s’escau, la base de sortida.',
    airfieldLabel: (kind: string, index: number) =>
      `${kind === 'helipad' ? 'Heliport' : kind === 'secondary' ? 'Pista secundària' : 'Pista'} ${index + 1}`,
    siteLabel: (count: number) => `Posició militar · ${count} objectes`,
    placeTypes: {
      NameCityCapital: 'Capital',
      NameCity: 'Ciutat',
      NameVillage: 'Poble',
      NameLocal: 'Indret',
      NameMarine: 'Zona marina',
      Hill: 'Turó',
      Mount: 'Muntanya',
      Airport: 'Aeroport',
      StrongpointArea: 'Punt fort',
      ViewPoint: 'Mirador',
      RockArea: 'Roquissar',
      VegetationBroadleaf: 'Bosc',
      VegetationFir: 'Avetosa',
      VegetationPalm: 'Palmerar',
      VegetationVineyard: 'Vinya',
      BorderCrossing: 'Pas fronterer',
      CulturalProperty: 'Patrimoni',
      CivilDefense: 'Protecció civil',
      SafetyZone: 'Zona segura',
      FlatArea: 'Lloc pla',
      FlatAreaCity: 'Lloc pla (ciutat)',
      FlatAreaCitySmall: 'Lloc pla petit (ciutat)',
    } as Record<string, string>,
    siteKinds: {
      hq: 'comandament',
      barracks: 'barracons',
      tower: 'torres',
      hangar: 'hangars',
      helipad: 'heliports',
      radar: 'radars',
      bunker: 'búnquers',
    } as Record<string, string>,
    /** The terrain sheet (layout A, the owner's choice of 2026-10-18): key figures, then cards by topic. */
    sheet: {
      keyFigures: 'Xifres clau',
      cards: {
        relief: 'Relleu',
        water: 'Aigua i costa',
        places: 'Poblacions i llocs',
        roads: 'Vies i ponts',
        air: 'Pistes i heliports',
        military: 'Posicions militars',
        buildings: 'Edificis',
        objects: 'Objectes del terreny',
        ground: 'Terra sota els peus',
        missions: 'Missions',
      },
      key: {
        land: 'terra ferma',
        highest: 'punt més alt',
        towns: 'ciutats i pobles',
        buildings: 'edificis',
        runways: 'pistes d’aterratge',
        bridges: 'ponts',
        sites: 'posicions militars',
        missions: 'tipus de missió',
      },
      lowest: 'Punt més baix',
      namedHills: 'Turons amb nom',
      water: 'Aigua',
      marine: 'Zones marines',
      landable: 'Costa on es pot desembarcar',
      landableValue: (percent: number) => `${percent} %`,
      shorePoints: (landable: string, all: string) => `${landable} de ${all} punts de costa`,
      capitals: 'Capitals',
      cities: 'Ciutats',
      villages: 'Pobles',
      localities: 'Indrets',
      landmarks: 'Fites',
      landmarksHint: 'esglésies, fàbriques, torres, cementiris…',
      roadTypes: {
        'MAIN ROAD': 'Carreteres principals',
        ROAD: 'Carreteres',
        TRACK: 'Camins de terra',
        TRAIL: 'Senders',
        footpath: 'Corriols',
      } as Record<string, string>,
      km: (v: string) => `${v} km`,
      roadTotal: 'Xarxa de carreteres i camins',
      unmeasured: 'sense mesura',
      fords: 'Guals',
      deadEnds: 'Camins sense sortida',
      junctions: 'Cruïlles',
      bridgesOver: (all: number, water: number) => `${all} · ${water} sobre aigua`,
      longestBridge: 'Pont més llarg',
      helipads: 'Heliports',
      biggestSite: ['La més gran', 'La segona', 'La tercera'],
      siteValue: (count: number, radius: number) => `${count} objectes · ${radius} m`,
      noSites:
        'La inspecció no hi ha trobat cap agrupació d’objectes militars. Els búnquers i les garites soltes es compten a Edificis.',
      models: (n: string) => `${n} models`,
      ruins: 'Llocs amb ruïnes',
      ruinsHint: 'ruïnes que el terreny ja porta de fàbrica',
      lamps: 'Fanals',
      walls: 'Murs',
      fences: 'Tanques',
      rocks: 'Roques',
      powerLines: 'Línies elèctriques',
      spread: (pieces: string, hectares: string) => `${pieces} · en ${hectares} ha`,
      minor: {
        railway: 'Via del tren',
        shipwrecks: 'Derelictes',
        busStops: 'Parades d’autobús',
        crosses: 'Creus',
        tourism: 'Llocs turístics',
        fountains: 'Fonts',
        stacks: 'Xemeneies',
        quays: 'Molls',
      } as Record<string, string>,
      surfacesHint: 'De cada mostra de terra ferma, el tipus de sòl que hi ha.',
      surfaces: {
        water: 'Fons d’aigua',
        forest: 'Bosc',
        grass: 'Herba',
        field: 'Conreu',
        paved: 'Asfalt i formigó',
        sand: 'Sorra',
        desert: 'Desert',
        marsh: 'Aiguamoll',
        snow: 'Neu',
        stone: 'Pedra',
        dirt: 'Terra',
      } as Record<string, string>,
      otherSurface: 'Altres',
      missionsFit: (fit: number, all: number) => `${fit} de ${all}`,
      missionsHint: 'tipus de missió que s’hi poden generar amb els mods del terreny',
      missionsAll: 'Hi caben tots.',
      missionsOut: 'No hi caben:',
      kinds: {
        airfield: 'aeròdrom',
        high_ground: 'terreny elevat',
        settlement: 'poblacions',
        site: 'posicions militars',
        water: 'aigua',
        landmark: 'fites',
        camp: 'campament',
        coast: 'costa',
        bridge: 'ponts',
      } as Record<string, string>,
      offers: 'Terreny que ofereix',
      duration: (text: string) => `la inspecció va durar ${text}`,
      seconds: (s: number) => (s < 120 ? `${s} s` : `${Math.round(s / 60)} min`),
      current: (v: number) => `Inspecció v${v}, la vigent`,
      types: {
        airport_terminal: 'Terminals d’aeroport',
        airport_tower: 'Torres de control',
        apartment: 'Blocs de pisos',
        barn: 'Pallers',
        barracks: 'Barracons',
        bell_tower: 'Campanars',
        bunker: 'Búnquers',
        castle: 'Castells',
        cemetery: 'Tombes i creus',
        chapel: 'Capelles',
        church: 'Esglésies',
        clinic: 'Dispensaris',
        container: 'Contenidors',
        crane: 'Grues',
        damaged: 'Edificis malmesos',
        dome: 'Cúpules',
        factory: 'Fàbriques',
        farm: 'Granges',
        fortress: 'Fortaleses',
        fuel_station: 'Benzineres',
        guard_house: 'Garites',
        hangar: 'Hangars',
        hospital: 'Hospitals',
        hotel: 'Hotels',
        house: 'Cases',
        house_addon: 'Annexos de casa',
        house_big: 'Cases grans',
        industrial_shed: 'Naus industrials',
        kiosk: 'Quioscos',
        lighthouse: 'Fars',
        market: 'Mercats',
        military_house: 'Edificis militars',
        military_hq: 'Comandaments militars',
        military_office: 'Oficines militars',
        monument: 'Monuments',
        office: 'Oficines',
        pier: 'Molls',
        platform: 'Plataformes',
        police: 'Policia',
        power_plant: 'Centrals elèctriques',
        prison: 'Presons',
        pylon: 'Torres elèctriques',
        radar: 'Radars',
        ruin: 'Ruïnes',
        school: 'Escoles',
        shack: 'Barraques',
        shelter: 'Refugis',
        shop: 'Botigues',
        solar_plant: 'Plaques solars',
        stadium: 'Estadis',
        station: 'Estacions',
        storage_tank: 'Dipòsits',
        supermarket: 'Supermercats',
        temple: 'Temples',
        tent: 'Tendes',
        tower: 'Torres',
        transmitter: 'Antenes',
        trench: 'Trinxeres',
        unfinished: 'Obres a mig fer',
        view_tower: 'Miradors',
        villa: 'Viles',
        warehouse: 'Magatzems',
        watchtower: 'Torres de guaita',
        water_tank: 'Cisternes',
        water_tower: 'Dipòsits d’aigua',
        wind_turbine: 'Aerogeneradors',
        windmill: 'Molins de vent',
        workshop: 'Tallers',
      } as Record<string, string>,
      otherType: 'Altres',
    },
  },
  voicePairs: {
    title: 'Parells de veu',
    intro:
      'La mateixa frase dita de dues maneres. Escolta les dues i tria la que sentiries trenta vegades en una nit. Fins que no vegis el recompte no sabràs quina és quina.',
    progress: (done: number, total: number) => `${done} de ${total} parells triats`,
    listen: (side: string) => `Escolta la ${side}`,
    prefer: (side: string) => `Prefereixo la ${side}`,
    showTally: 'Mostra el recompte',
    tallyTitle: 'Recompte',
    tallyRow: (left: string, l: number, right: string, r: number, listeners: number) =>
      `${left}: ${l} · ${right}: ${r} (${listeners} ${listeners === 1 ? 'oient' : 'oients'})`,
    voiceOff: 'Aquesta plataforma no té la veu engegada: no sonarà res.',
    failed: 'No ha anat bé. Torna-ho a provar.',
  },
  voiceRegion: {
    title: 'Accent de les veus',
    label: 'Accent',
    kinds: { island: 'illa', continental: 'continent' } as Record<string, string>,
    sources: {
      override: 'fixat per un administrador',
      survey: 'segons la inspecció',
      default: 'per defecte',
    } as Record<string, string>,
    intro:
      'Amb quin accent parlen l’enemic i la gent del lloc en aquest mapa: d’illa o de continent. Ho diu la inspecció (si la massa de terra més gran toca la vora del mapa, és continent); un administrador ho pot fixar si el mapa es coneix d’una altra manera. Les missions ja generades conserven l’accent amb què es van escriure.',
    tableTitle: 'Accent de les veus per terreny',
    tableIntro:
      'Cada terreny inspeccionat, amb l’accent que li toca i per què. Si algun mapa no és el que ha de ser, fixa’l aquí o a la pàgina del terreny.',
    colWorld: 'Terreny',
    colKind: 'Accent',
    colSource: 'D’on surt',
    colWhy: 'Per què',
    colSet: 'Fixa-ho',
    fromSurvey: 'El de la inspecció',
    setIsland: 'Illa',
    setContinental: 'Continent',
    saved: (world: string, kind: string) => `${world}: ara és ${kind}.`,
    empty: 'Encara no hi ha cap terreny inspeccionat.',
    loadError: 'No s’ha pogut llegir l’accent dels terrenys.',
    saveError: 'No s’ha pogut desar l’accent.',
    /** The platform's reasons, said in Catalan; an unknown one is shown as it came. */
    why: (text: string): string => {
      if (text === 'set on the terrain page') return 'fixat a la pàgina del terreny';
      if (text === 'no survey') return 'el terreny no s’ha inspeccionat';
      if (text === 'the survey stored no land masses')
        return 'la inspecció no va desar cap massa de terra';
      if (text === 'the survey stored no biggest land mass')
        return 'la inspecció no va desar quina és la massa de terra més gran';
      if (text === 'the biggest land mass does not reach the edge')
        return 'la massa de terra més gran no toca la vora del mapa';
      const edge = /^the biggest land mass reaches the edge at (-?\d+),(-?\d+)$/.exec(text);
      if (edge)
        return `la massa de terra més gran toca la vora del mapa (a ${edge[1]}, ${edge[2]})`;
      return text;
    },
  },
  catalogPage2: {
    serverTitle: 'Servidor (conjunt de mods)',
    pickServerFirst: 'Tria un servidor per veure què està a punt i què falta.',
    steps: 'Preparació del conjunt de mods',
    step1Title: 'El que porta el servidor',
    step1Intro:
      'Els mods del Workshop i els DLC que el servidor té carregats ara: aquest és el conjunt de mods. Si es canvien al panell, cal tornar a llegir-ne el contingut.',
    step2Title: 'Contingut escanejat',
    step2Intro:
      'Un servidor temporal llegeix terrenys, faccions, grups i vehicles d’aquests mods durant uns minuts; el servidor triat no es toca.',
    step3Title: 'Perfils derivats',
    step3Intro:
      'De cada facció escanejada se’n deriva un perfil que el generador de missions fa servir.',
    profilesCount: (n: number) => (n === 1 ? '1 perfil' : `${n} perfils`),
    noProfiles: 'Cap perfil encara',
    rescan: 'Torna a escanejar',
    scannedWithoutOrigins: 'Escanejat sense els mods d’origen',
    scannedWithoutOriginsTitle:
      'Aquest contingut es va escanejar abans que la plataforma guardés de quin mod ve cada cosa. Torna a escanejar el servidor per veure-ho a les faccions, els equipaments i les unitats.',
    statWorlds: 'Terrenys',
    statFactions: 'Faccions',
    statGroups: 'Grups',
    statVehicles: 'Vehicles',
    statWeapons: 'Armes i peces',
    tabTerrains: 'Terrenys',
    tabFactions: 'Faccions',
    tabLoadouts: 'Equipaments',
    terrainSearch: 'Cerca un terreny',
    terrainName: 'Nom',
    terrainClass: 'Classe',
    terrainShowClass: 'Mostra la classe',
    terrainOnlyMissing: 'Només els que falten',
    terrainSize: 'Mida',
    terrainSource: 'Origen',
    terrainVanilla: 'Vanilla',
    terrainWorkshop: (id: number) => `Workshop ${id}`,
    /** The tooltip on a named mod: the id is still what the panel and the Workshop are addressed by. */
    terrainModTitle: (id: number) => `Workshop ${id}`,
    terrainMap: 'Mapa',
    terrainMapLocal: 'baixat',
    terrainMapRemote: 'a l’Atlas',
    terrainMapNone: 'sense mapa',
    terrainMapDownloading: 'baixant…',
    terrainMapGet: 'Baixa’l',
    terrainMapAll: 'Baixa els mapes',
    terrainMapHint:
      'Els mapes venen del PLANOPS Atlas. Baixar-los els guarda en aquest servidor: després es dibuixen des d’aquí i no es torna a consultar l’Atlas.',
    terrainMapSize: (bytes: number) =>
      bytes > 1024 * 1024
        ? `${Math.round(bytes / (1024 * 1024))} MB`
        : `${Math.round(bytes / 1024)} kB`,
    terrainSurvey: 'Inspecció',
    terrainSurveyDo: 'Inspecciona',
    terrainSurveyAgain: 'Torna a inspeccionar',
    terrainSurveyAll: 'Inspecciona els pendents',
    terrainSurveyAllMaps: 'Inspecciona tots els mapes',
    terrainSurveyStates: {
      QUEUED: 'a la cua',
      STARTING: 'arrencant',
      RUNNING: 'inspeccionant',
      DONE: 'inspeccionat',
      FAILED: 'ha fallat',
      NONE: 'pendent',
    },
    terrainSurveyPending: (n: number, total: number) =>
      n === 1
        ? `1 terreny dels ${total} encara no s’ha inspeccionat: el generador no en sap ni l’aigua ni el relleu.`
        : `${n} terrenys dels ${total} encara no s’han inspeccionat: el generador no en sap ni l’aigua ni el relleu.`,
    terrainSurveyQueued: (n: number) =>
      n === 1 ? '1 inspecció a la cua' : `${n} inspeccions a la cua`,
    terrainSurveyRunning: (world: string) => `Inspeccionant ${world}…`,
    terrainSurveyHint:
      'Cada inspecció és un servidor Arma que arrenca, llegeix el terreny i s’esborra: uns minuts per terreny, un darrere l’altre.',
    terrainSurveySequential: 'un servidor cada cop',
    terrainSurveyPause: 'Atura la cua d’inspeccions',
    terrainSurveyResume: 'Reprèn la cua d’inspeccions',
    terrainSurveyPaused:
      'La cua d’inspeccions està aturada: no n’arrenca cap de nova fins que es reprengui. La que ja corre acaba.',
    terrainSurveyAllMapsHint:
      'Sense servidor triat, inspecciona tots els mapes del panell d’un en un, cadascun en un servidor propi amb només el mod que el porta, encara que cap servidor el faci servir. Són hores de servidor: la cua sobreviu a un reinici.',
    terrainSurveySkipped: (n: number) =>
      n === 1
        ? '1 terreny no s’ha encuat: ni els seus propis fitxers ni cap escaneig no en declaren el món, i sense això la missió d’inspecció n’hauria d’endevinar l’addon. Llegeix el contingut d’un servidor que el porti.'
        : `${n} terrenys no s’han encuat: ni els seus propis fitxers ni cap escaneig no en declaren el món, i sense això la missió d’inspecció n’hauria d’endevinar l’addon. Llegeix el contingut d’un servidor que els porti.`,
    terrainsEmpty: 'Cap terreny indexat.',
    terrainsEmptyHint: 'Indexa els terrenys perquè apareguin aquí.',
    factionName: 'Nom',
    factionSide: 'Bàndol',
    factionClass: 'Classe',
    factionOrigin: 'Origen',
    factionDerived: 'derivat',
    factionEdited: 'editat',
    /**
     * Release D, D5.5: whether a faction is irregular (guerrillas, insurgents, a
     * militia). An editor marks it; otherwise it is read from the faction's names.
     */
    factionIrregular: 'Irregular',
    factionIrregularOf: (name: string) => `Irregular: ${name}`,
    factionIrregularYes: 'Sí',
    factionIrregularNo: 'No',
    factionIrregularByNames: (derived: boolean | null) =>
      derived === null ? 'Segons el catàleg' : `Segons el catàleg (${derived ? 'sí' : 'no'})`,
    /**
     * Whose cars a faction's men ride when it has no mounted group of its own
     * (2026-10-10): its own, the faction its own groups name, a donor an editor
     * declares here, or none and the mounted forces go on foot.
     */
    factionRides: 'Vehicles',
    factionRidesOf: (name: string) => `Vehicles de: ${name}`,
    factionRidesOwn: 'Propis',
    factionRidesGroups: (faction: string) => `Dels seus grups: ${faction}`,
    factionRidesDonor: (faction: string) => `Donant: ${faction}`,
    factionRidesNone: 'Cap: les forces muntades van a peu',
    factionRidesUnknown: 'Sense catàleg',
    factionRidesNoDonor: 'Cap donant',
    factionRidesHint:
      'Una facció sense cotxes propis només en fa servir si algú en declara aquí el donant. Mai se’n manlleven pel nom ni pel bàndol.',
    factionsIntro:
      'Els perfils de facció del servidor triat, tal com els farà servir el generador.',
    factionsEmpty: 'Cap perfil de facció.',
    factionsEmptyHint: 'Llegeix el contingut dels mods i deriva els perfils.',
    flagsTitle: 'Banderes que falten',
    flagsCheck: 'Comprova les banderes',
    flagsAllThere: 'Totes les faccions tenen bandera.',
    flagsMissing: (n: number) =>
      `${n} ${n === 1 ? 'facció no té' : 'faccions no tenen'} bandera pròpia.`,
    flagsHint:
      'Un servidor dedicat mai no renderitza, així que SteamCMD li dona les textures del joc base buidades: la bandera d’una facció vanilla hi és com un marcador de 8×8. L’única còpia bona és la d’una instal·lació de client. Copia-hi el fitxer amb aquest nom a GAME_ART_DIR i ja sortirà; les faccions de mods no en necessiten cap.',
    loadoutPasteTitle: 'Enganxa i comprova',
    loadoutPasteHelp:
      'Al joc, executa getUnitLoadout player i enganxa el resultat; la comprovació diu quines classes no porta aquest servidor.',
    loadoutImportTitle: 'Importa d’una missió o d’una sessió',
    loadoutImportHelp:
      'Recull els equipaments que ja hi ha en una carpeta de missió o en una sessió jugada: tant els que hi són escrits com a setUnitLoadout com els guions de l’Arsenal (addWeapon, addItemToVest…) de templates/loadouts.',
    loadoutSavedTitle: 'Equipaments desats',
    loadoutSavedEmpty: 'Cap equipament desat per a aquest conjunt de mods.',
    loadoutCandidates: 'Equipaments trobats',
    /**
     * The presets tab: units and groups saved once and picked afterwards, on
     * either side. Between a loadout (un home) and a perfil de facció (tota una
     * facció) no hi havia res, i per això cada element d'una missió generada era
     * una esquadra de Bohemia.
     */
    tabForces: 'Unitats i grups',
    forcesIntro:
      'Un preset d’unitat és un home: una classe, un equipament i una funció. Un preset de grup és una llista d’homes i els vehicles amb què arriben. Es poden fer servir des del pas de les nostres forces, des de l’editor i com a guarnició enemiga.',
    forceUnits: 'Unitats',
    forceGroups: 'Grups',
    forceNew: 'Nou preset',
    forceNewUnit: 'Nova unitat',
    forceNewGroup: 'Nou grup',
    forceName: 'Nom',
    forceSide: 'Bàndol',
    forceFaction: 'Facció',
    forceFactionAny: 'Cap en concret',
    forceUnitClass: 'Classe d’unitat',
    forceLoadout: 'Equipament',
    forceLoadoutNone: 'El de la unitat',
    forceRole: 'Funció',
    forceCategory: 'Categoria',
    forceMembers: 'Homes',
    forceMemberAdd: 'Afegeix un home',
    forceMemberRemove: 'Treu',
    forceMemberCount: 'Quants',
    forceMemberFrom: 'D’un preset d’unitat',
    forceMemberFromNone: 'Classe directa',
    forceVehicles: 'Vehicles',
    forceVehicleAdd: 'Afegeix un vehicle',
    forceSave: 'Desa',
    forceCancel: 'Cancel·la',
    forceClone: 'Duplica',
    forceDelete: 'Esborra',
    forceEdit: 'Edita',
    forceEmptyUnits: 'Encara no hi ha cap preset d’unitat.',
    forceEmptyGroups: 'Encara no hi ha cap preset de grup.',
    forceMissing: (n: number) => `${n} classes no són en aquest conjunt de mods`,
    forceMen: (n: number) => `${n} ${n === 1 ? 'home' : 'homes'}`,
    forceNeedsScan: 'Llegeix el contingut dels mods del servidor per triar classes del catàleg.',
    forceDeleteConfirm: 'Esborrar aquest preset?',

    /* ---- Composicions: conjunts d'objectes, importats d'on ja n'hi ha. */
    tabCompositions: 'Composicions',
    compositionsIntro:
      'Un conjunt d’objectes col·locat d’una peça: una base, un control de carretera, sacs terrers al voltant d’una arma. Se n’importen de les missions que ja hi ha al panell (els fitxers d’objects mapper que porten els frameworks i els objectes d’un mission.sqm en text), enganxant-ne una o pujant-ne un fitxer.',
    compositionFromMission: 'D’una missió del panell',
    compositionAnchor: 'Al voltant d’un objecte (classe)',
    compositionAnchorHint:
      'Buit: tota la missió, centrada. Amb una classe — ATLAS_B_LHD_helper per al vaixell — només el que hi ha a 130 m d’aquest objecte, en el seu propi marc, amb les places dels jugadors i els vehicles al lloc exacte on la missió els té.',
    compositionScan: 'Cerca-hi composicions',
    compositionFromWorkshop: 'D’un mod del Workshop',
    compositionWorkshopHint:
      'De la mateixa manera: instal·la l’ítem al panell i aquí se’n llegeixen els fitxers, també els que van dins dels PBO.',
    compositionPaste: 'Enganxa una composició',
    compositionPasteHelp:
      'Enganxa un array d’objects mapper (["Land_…",[x,y,z],dir],…) o el contingut d’un mission.sqm en text.',
    compositionRead: 'Llegeix',
    compositionUpload: 'Puja un fitxer',
    compositionFound: 'Composicions trobades',
    compositionSaved: 'Composicions desades',
    compositionEras: (name: string) => `Èpoques de ${name}`,
    compositionErasHint:
      'Les èpoques en què aquesta base es pot fer servir. Una base sense marcar serveix per a totes menys la Segona Guerra Mundial.',
    compositionSavedEmpty: 'Encara no n’hi ha cap.',
    compositionSave: 'Desa-la',
    compositionName: 'Nom',
    compositionSide: 'De qui és',
    compositionObjects: (n: number) => `${n} objectes`,
    compositionRadius: (m: number) => `${Math.round(m)} m de radi`,
    compositionForms: {
      objectsMapper: 'Objects mapper',
      missionSqm: 'mission.sqm',
    } as Record<string, string>,
    compositionNothingFound: 'En aquesta missió no s’hi ha trobat cap composició.',
    compositionDeleteConfirm: 'Esborrar aquesta composició?',

    /* ---- La biblioteca de composicions (docs/design/COMPOSITION_LIBRARY.md §6). */
    library: {
      viewLibrary: 'Biblioteca',
      viewImport: 'Importa',
      intro:
        'Només surten les composicions que aquest conjunt de mods pot muntar senceres: si li falta una sola peça, no hi és.',
      notScanned:
        'Llegeix el contingut dels mods del servidor per veure quines composicions s’hi poden muntar.',
      era: 'Època',
      theatre: 'Teatre',
      role: 'Paper',
      state: 'Estat',
      all: 'Totes',
      allTheatres: 'Tots',
      roles: {
        start_base: 'Base de partida',
        fob: 'Post avançat',
        scene: 'Escena de recepta',
      } as Record<string, string>,
      roleNames: {
        'start_base:camp': 'Base de partida',
        'start_base:site': 'Base en un lloc construït',
        'start_base:sea': 'Base al mar',
        fob: 'Post avançat',
      } as Record<string, string>,
      sceneOf: (recipe: string) => `Escena · ${recipe.replace(/_/g, ' ')}`,
      states: {
        all: 'Totes',
        enabled: 'Actives',
        unapproved: 'Pendents d’aprovar',
        disabled: 'Desactivades',
      } as Record<string, string>,
      chipEnabled: 'Activa',
      chipUnapproved: 'Pendent d’aprovar',
      chipDisabled: 'Desactivada',
      origins: {
        OWNER: 'Del propietari',
        AGENT: 'Feta per un agent',
        WORKSHOP: 'Workshop',
        MISSION: 'Importada',
        PLATFORM: 'De la plataforma',
      } as Record<string, string>,
      footprint: (m: number) => `${Math.round(m)} m d’abast`,
      count: (n: number) => `${n} ${n === 1 ? 'composició' : 'composicions'}`,
      empty: 'Cap composició d’aquest conjunt de mods no compleix aquests filtres.',
      noPictures: 'Encara sense fotos: es veu la planta',
      switchOn: (name: string) => `Activa ${name}`,
      switchOff: (name: string) => `Desactiva ${name}`,
      switchNeedsApproval: 'S’activa quan la versió actual està aprovada',
      reason: 'Motiu, si la desactives',
      reasonPlaceholder: 'Per exemple: massa semblant a una altra',
      approve: 'Aprova aquesta versió',
      approved: (date: string) => `Versió aprovada el ${date}`,
      approvedAlready: 'Aquesta versió ja està aprovada',
      notApproved:
        'No es pot activar fins que el propietari n’aprovi la versió actual mirant-ne les fotos.',
      close: 'Tanca',
      details: 'Dades',
      origin: 'Origen',
      author: 'Autor',
      licence: 'Llicència',
      classes: (n: number) => `${n} classes`,
      erasHere: 'Es pot muntar a',
      disabledBecause: (why: string) => `Desactivada: «${why}»`,
      incompatible: (n: number) => `Sense cap conjunt compatible (${n})`,
      incompatibleHint:
        'Composicions que cap conjunt de mods llegit no pot muntar senceres; només les veuen els administradors.',
      missingCount: (n: number) => `falten ${n} classes`,
      open: (name: string) => `Obre la fitxa de ${name}`,
      pictures: 'Fotos del banc',
      pictureOf: (view: string, world: string) => `${view} · ${world}`,
      views: {
        TOP: 'Des de dalt',
        VIEW_A: 'Vista 1',
        VIEW_B: 'Vista 2',
        VIEW_C: 'Vista 3',
        DETAIL: 'Detall',
      } as Record<string, string>,
      upload: 'Puja fotos del banc',
      uploadHint:
        'Fitxers que library_pictures.py anomena <clau>__<VISTA>__<terreny>.jpg; un altre nom puja amb la vista i el terreny triats aquí.',
      uploadView: 'Vista',
      uploadWorld: 'Terreny',
      uploaded: (n: number) => `${n} ${n === 1 ? 'foto pujada' : 'fotos pujades'}`,
      removePicture: (view: string) => `Treu la foto ${view}`,
      pictureErrors: {
        pictures_off: 'La plataforma no té cap carpeta per desar fotos.',
        not_a_picture: 'Aquest fitxer no és una foto (JPEG, PNG o WebP).',
        too_big: 'La foto passa de 600 KB.',
        bad_view: 'Aquesta vista no és cap de les del banc.',
        bad_world: 'El nom del terreny no és vàlid.',
      } as Record<string, string>,
      /* ---- La importació d’una composició (docs/design/COMPOSITION_LIBRARY.md §5 i §10). */
      workshop: {
        title: 'Importa una composició de l’Eden o del Workshop',
        intro:
          'Puja el composition.sqe de la composició o un mission.sqm desat de l’Eden. La plataforma en llegeix les peces, deixa fora el que no es pot muntar, proposa on van la bandera, l’arsenal i la resta de punts, i la desa desactivada i sense aprovar fins que en vegis les fotos. El codi d’inici d’una composició no s’executa mai.',
        file: 'Fitxer (composition.sqe o mission.sqm)',
        link: 'Enllaç de l’element del Workshop',
        linkHint:
          'Opcional. En llegim el títol, la imatge i la data de l’última actualització; la imatge s’enllaça, no es copia.',
        read: 'Llegeix',
        reading: 'Llegint…',
        refusals: {
          over_cap: (n: number, limit: number) =>
            `Aquesta composició té ${n} peces i el màxim és ${limit}. No se’n desa cap de retallada: cal una composició més petita.`,
          no_pieces: 'En aquest fitxer no hi ha cap peça que es pugui muntar.',
          too_many_read: (n: number, limit: number) =>
            `El fitxer té ${n} objectes, més de ${limit}: és una missió, no una composició.`,
          too_big: 'El fitxer és massa gran per ser una composició.',
          binarised:
            'Aquest mission.sqm està binaritzat. Desa’l de l’Eden com a text, o puja el composition.sqe.',
        } as Record<string, string | ((n: number, limit: number) => string)>,
        saveErrors: {
          name: 'Posa-li un nom.',
          roles: 'Tria què pot ser: base de partida o post avançat.',
          tags: 'Tria almenys una època.',
          bad_link: 'L’enllaç no és el d’un element del Workshop.',
          meta: 'No s’ha pogut llegir el que has triat.',
          anchor: 'Un dels punts no és vàlid.',
          key_taken: 'Ja hi ha una composició del dipòsit amb aquesta clau.',
        } as Record<string, string>,
        anchorMissing: (name: string) => `Falta col·locar: ${name}.`,
        workshopErrors: {
          bad_link:
            'Això no és l’enllaç d’un element del Workshop (steamcommunity.com/sharedfiles/filedetails/?id=…).',
          steam_unavailable:
            'Steam no ha contestat: es desa només l’enllaç, sense títol ni data. Escriu l’autor a mà.',
        } as Record<string, string>,
        itemTitle: 'Element del Workshop',
        itemUpdated: (date: string) => `L’autor la va canviar per última vegada el ${date}.`,
        previewAlt: 'Imatge de l’element al Workshop',
        openItem: 'Obre l’element al Workshop',
        summary: (read: number, kept: number) =>
          `${read} objectes llegits; en queden ${kept} peces.`,
        leftOut: 'Deixat fora',
        dropped: {
          men: (n: number) => `${n} ${n === 1 ? 'soldat o tripulant' : 'soldats o tripulants'}`,
          vehicles: (n: number) =>
            `${n} ${n === 1 ? 'vehicle' : 'vehicles'} buit${n === 1 ? '' : 's'}`,
          staticWeapons: (n: number) => `${n} ${n === 1 ? 'arma estàtica' : 'armes estàtiques'}`,
          roads: (n: number) => `${n} ${n === 1 ? 'peça de carretera' : 'peces de carretera'}`,
          modules: (n: number) => `${n} ${n === 1 ? 'mòdul' : 'mòduls'}`,
          triggers: (n: number) => `${n} ${n === 1 ? 'activador' : 'activadors'}`,
          markers: (n: number) => `${n} ${n === 1 ? 'marcador' : 'marcadors'}`,
          waypoints: (n: number) => `${n} ${n === 1 ? 'punt de ruta' : 'punts de ruta'}`,
          leftOut: (n: number) => `${n} peces apartades pel fitxer de papers`,
          inits: (n: number) =>
            `${n} ${n === 1 ? 'codi d’inici' : 'codis d’inici'}: no s’executa mai ni es desa`,
        } as Record<string, (n: number) => string>,
        checks: {
          heights_guessed: (n: number) =>
            `${n} ${n === 1 ? 'peça té' : 'peces tenen'} l’alçada deduïda del terra del voltant: mira-${n === 1 ? 'la' : 'les'} a les fotos.`,
          classes_unmeasured: (n: number) =>
            `${n} ${n === 1 ? 'classe encara no s’ha mesurat' : 'classes encara no s’han mesurat'} al laboratori; es mesuren amb la primera tanda de fotos.`,
          mod_set_not_scanned: () =>
            'Aquest conjunt de mods no s’ha llegit: no se sap què hi falta ni quins vehicles hi ha.',
          lamps_lit: (n: number) =>
            `${n} ${n === 1 ? 'llum s’encendrà' : 'llums s’encendran'} de nit.`,
          off_centre: (n: number) =>
            `El mig del recinte és a ${n} m del centre de la composició: l’abast pot sortir massa gran.`,
          no_gate: () => 'No s’ha trobat cap entrada: col·loca-la tu.',
          no_park_lane: () =>
            'Cap lloc d’aparcament no arriba a l’entrada per un carril lliure de 3 m.',
          helipad_in_gate_lane: () =>
            'L’helipuert de l’autor tapa el camí d’entrada: no es proposa com a helipuert.',
          arsenal_inside_closed: () => 'L’arsenal queda dins d’una peça tancada.',
          medic_inside_closed: () => 'El punt mèdic queda dins d’una peça tancada.',
        } as Record<string, (n: number) => string>,
        unknownCheck: (key: string) => `Avís: ${key}`,
        modsTitle: 'Peces de mods o de DLC',
        modsHint: 'Les fotos diuen si es veu bé; un client sense el DLC no les veu.',
        eraHint: (era: string) => `sembla d’època ${era}`,
        factionsTitle: 'Peces d’una altra facció que la dels jugadors',
        guessedTitle: 'Alçades deduïdes',
        missingTitle: 'Classes que falten al conjunt de mods',
        missingNone: 'Cap classe no falta.',
        variant: 'Fes-ne una variant sense aquestes peces',
        variantNote: (n: number) =>
          `${n} ${n === 1 ? 'peça deixada fora' : 'peces deixades fora'}.`,
        fieldsTitle: 'Què és',
        name: 'Nom (en català)',
        roles: 'Pot ser',
        roleOptions: {
          'start_base:camp': 'Base de partida',
          fob: 'Post avançat',
        } as Record<string, string>,
        tags: 'Època i teatre',
        tagEra: 'Època',
        tagTheatre: 'Teatre',
        anyTheatre: 'Qualsevol',
        addTag: 'Afegeix',
        removeTag: (label: string) => `Treu ${label}`,
        author: 'Autor',
        authorHint: 'Steam no dóna el nom de l’autor: escriu-lo tal com surt al Workshop.',
        licence: 'Permís, si n’hi ha (amb paraules)',
        licenceHint: 'No cal cap permís per activar-la; l’autor i l’enllaç sortiran a la fitxa.',
        anchorsTitle: 'Punts de la base',
        sketchHint:
          'Arrossega cada punt, o tria’l i mou-lo amb les fletxes (Maj, 5 m). L’entrada mira a l’est.',
        sketch: 'Planta amb els punts',
        anchorNames: {
          spawn: 'Aparició',
          flag: 'Bandera',
          orders: 'Ordres',
          arsenal: 'Arsenal',
          medic: 'Punt mèdic',
          gate: 'Entrada',
          park: 'Aparcament',
          helipad: 'Helipuert',
        } as Record<string, string>,
        anchorHows: {
          catalogue: 'pel catàleg',
          name: 'pel nom de la classe',
          class: 'per la classe',
          gap: 'pel buit del perímetre',
          'open ground': 'terreny lliure',
          you: 'posat per tu',
          'to place': 'per col·locar',
        } as Record<string, string>,
        toPlace: 'per col·locar',
        nudge: (name: string) => `${name}: arrossega o mou amb les fletxes`,
        save: 'Desa a la biblioteca',
        saving: 'Desant…',
        saved: (name: string) =>
          `«${name}» és a la biblioteca, desactivada i sense aprovar: falta pujar-ne les fotos i que el propietari l’aprovi.`,
        cannotSave: 'Abans de desar:',
        needName: 'posa-li un nom',
        needRole: 'tria què pot ser',
        needTag: 'tria una època',
        needAnchors: (names: string) => `col·loca ${names}`,
        reset: 'Torna a començar',
      },
    },
  },
  /**
   * A hand-made enemy faction's roster (docs/design/HANDMADE_ENEMY_FACTIONS.md):
   * its men, each with a role and a loadout, its vehicles and its statics, of
   * any faction of the server.
   */
  factionRoster: {
    column: 'Plantilla',
    columnHint:
      'Una facció feta a mà té homes, vehicles i armes estàtiques propis, de qualsevol mod del servidor, amb l’equipament de cada home.',
    none: 'De la facció',
    summary: (men: number, vehicles: number, statics: number) =>
      `${men} ${men === 1 ? 'home' : 'homes'}, ${vehicles} ${vehicles === 1 ? 'vehicle' : 'vehicles'}, ${statics} ${statics === 1 ? 'arma' : 'armes'}`,
    edit: 'Edita la plantilla',
    make: 'Fes-li una plantilla',
    clone: 'Fes-ne una facció a mà',
    cloneName: (name: string) => `${name} (feta a mà)`,
    cloned: (name: string) => `S’ha creat «${name}». Ja en pots editar la plantilla.`,
    title: (name: string) => `Plantilla de ${name}`,
    intro:
      'Els grups enemics es fan amb aquests homes, cadascun amb el seu equipament. Cada grup el porta un líder; la resta es tria segons el pes. Els franctiradors, la tripulació i l’oficial només surten quan algú els demana pel nom: una parella de franctiradors, la tripulació d’un vehicle, el comandant d’un lloc de comandament.',
    menTitle: 'Homes',
    vehiclesTitle: 'Vehicles',
    vehiclesHint:
      'Els que fan servir les forces muntades, les columnes i els combois. Sense cap, els de la facció base.',
    staticsTitle: 'Armes estàtiques',
    staticsHint: 'Sense cap d’un tipus, la que trobi el joc de la facció base.',
    unitClass: 'Classe',
    role: 'Rol',
    label: 'Nom',
    loadout: 'Equipament',
    loadoutOwn: 'El de la classe',
    weight: 'Pes',
    kind: 'Tipus',
    className: 'Classe',
    add: 'Afegeix',
    remove: 'Treu',
    save: 'Desa la plantilla',
    clear: 'Esborra la plantilla',
    clearConfirm:
      'Esborrar la plantilla? La facció tornarà a fer servir els homes i vehicles de la facció base.',
    saved: 'Plantilla desada.',
    cleared: 'Plantilla esborrada.',
    close: 'Tanca',
    search: 'Cerca per nom o classe',
    noLeader: 'Cal com a mínim un líder.',
    roles: {
      leader: 'Líder',
      rifleman: 'Fuseller',
      autorifleman: 'Fuseller automàtic',
      machinegunner: 'Metrallador',
      grenadier: 'Granader',
      at: 'Antitanc',
      aa: 'Antiaeri',
      marksman: 'Tirador',
      sniper: 'Franctirador',
      medic: 'Metge',
      engineer: 'Enginyer',
      uav: 'Operador de drons',
      crew: 'Tripulant',
      officer: 'Oficial',
    } as Record<string, string>,
    kinds: {
      hmg: 'Metralladora pesant',
      gmg: 'Llançagranades',
      at: 'Antitanc',
      aa: 'Antiaèria',
      mortar: 'Morter',
    } as Record<string, string>,
  },
  /**
   * The mod a faction, a unit or an item comes from (roadmap item
   * mod-d-origen), as the terrain tab's origin column says a map's.
   */
  modOrigin: {
    column: 'Mod',
    game: 'Arma 3',
    workshop: (id: number) => `Workshop ${id}`,
    cdlcTitle: 'DLC de creadors',
    gameTitle: 'Joc base',
    modTitle: (id: number | null) => (id ? `Mod del Workshop ${id}` : 'Mod'),
    unknown: 'Desconegut',
    unknownTitle: 'Cap mod del contingut llegit no defineix aquesta classe.',
    unread: 'Sense llegir',
    unreadTitle:
      'El contingut d’aquest servidor es va escanejar abans que se’n guardés el mod d’origen. Torna’l a escanejar per veure de quin mod ve cada cosa.',
    loadoutLabel: 'Mods de l’equipament',
  },
  /**
   * The loadout editor (roadmap item faccions-i-equipaments): one kit, piece by piece, chosen
   * only from the classes of the mod set. Route: /catalog/loadouts/:id and /catalog/loadouts/new.
   */
  loadoutEditor: {
    back: 'Equipaments',
    titleNew: 'Nou equipament',
    title: (name: string) => `Equipament «${name}»`,
    intro:
      'Tria cada peça entre les classes dels mods d’aquest servidor. El que no tries es queda com està; l’equipament només es desa si totes les peces existeixen i van al lloc que toca.',
    loading: 'Carregant l’equipament…',
    notFound: 'No hi ha cap equipament amb aquest número.',
    noModSet:
      'Falta el servidor: obre l’editor des de la pàgina d’equipaments, amb un servidor triat.',
    nameLabel: 'Nom',
    roleLabel: 'Rol',
    roleNone: 'Cap',
    sideLabel: 'Bàndol',
    sideNone: 'Cap',
    save: 'Desa l’equipament',
    saving: 'Desant…',
    saved: 'Equipament desat.',
    saveFailed: 'No s’ha pogut desar.',
    checking: 'Comprovant…',
    allGood: 'Totes les peces existeixen al conjunt de mods i van al lloc que toca.',
    problemsTitle: (n: number) => `${n} ${n === 1 ? 'cosa no va' : 'coses no van'}`,
    choose: 'Tria',
    change: 'Canvia',
    remove: 'Treu',
    none: 'Res',
    unnamed: 'Sense peça triada',
    unnamedHint: 'Aquest recipient porta coses però no té cap peça: tria quina és.',
    contents: 'Contingut',
    addContent: 'Afegeix al contingut',
    contentsEmpty: 'Buit',
    quantity: 'Quantitat',
    magazines: 'Carregadors',
    addMagazine: 'Afegeix un carregador',
    twoMagazines: 'Una arma només porta dos tipus de carregador.',
    linkedTitle: 'Objectes enllaçats',
    linkedHint: 'Mapa, GPS, ràdio, brúixola, rellotge i visió nocturna.',
    addLinked: 'Afegeix un objecte enllaçat',
    slotsTitle: 'Peces',
    weaponsTitle: 'Armes',
    pickerTitle: 'Tria una peça',
    pickerFor: (what: string) => `Triant: ${what}`,
    pickerIdle: 'Prem «Tria» en una peça per veure què en té el servidor.',
    searchLabel: 'Cerca per nom o classe',
    kindAll: 'Tot',
    results: (shown: number, total: number) => `${shown} de ${total}`,
    more: 'Mostra’n més',
    noResults: 'El servidor no té res d’aquest tipus amb aquesta cerca.',
    noCatalogue:
      'Aquest conjunt de mods encara no s’ha escanejat: no hi ha classes entre les quals triar.',
    pickIt: (name: string) => `Tria ${name}`,
    slots: {
      headgear: 'Casc o gorra',
      goggles: 'Ulleres',
      uniform: 'Uniforme',
      vest: 'Armilla',
      backpack: 'Motxilla',
      primary: 'Arma principal',
      launcher: 'Llançador',
      handgun: 'Pistola',
      binocular: 'Binocles',
      linkedItems: 'Objecte enllaçat',
      kit: 'Equipament',
      modSet: 'Conjunt de mods',
    } as Record<string, string>,
    parts: {
      optic: 'mira',
      muzzle: 'boca',
      laser: 'làser o llanterna',
      bipod: 'bípode',
      magazine: 'carregador',
      contents: 'contingut',
    } as Record<string, string>,
    kinds: {
      uniform: 'Uniformes',
      vest: 'Armilles',
      headgear: 'Cascs i gorres',
      backpack: 'Motxilles',
      goggles: 'Ulleres',
      primary: 'Armes principals',
      launcher: 'Llançadors',
      handgun: 'Pistoles',
      binocular: 'Binocles',
      optic: 'Mires',
      muzzle: 'Boques',
      laser: 'Làsers i llanternes',
      bipod: 'Bípodes',
      item: 'Objectes',
      magazine: 'Carregadors',
    } as Record<string, string>,
    kindIs: {
      uniform: 'un uniforme',
      vest: 'una armilla',
      headgear: 'un casc o una gorra',
      backpack: 'una motxilla',
      goggles: 'unes ulleres',
      primary: 'una arma principal',
      launcher: 'un llançador',
      handgun: 'una pistola',
      binocular: 'uns binocles',
      optic: 'una mira',
      muzzle: 'un accessori de boca',
      laser: 'un làser o una llanterna',
      bipod: 'un bípode',
      item: 'un objecte',
      magazine: 'un carregador',
    } as Record<string, string>,
    problem: {
      not_in_mod_set: (cls: string) => `«${cls}» no existeix als mods d’aquest servidor.`,
      wrong_kind: (cls: string, found: string, kindIs: string) =>
        `«${cls}» és ${kindIs || found} i no pot anar aquí.`,
      bad_count: (cls: string) => `La quantitat de «${cls}» ha de ser entre 1 i 99.`,
      too_many_magazines: () => 'Una arma només porta dos tipus de carregador.',
      empty: () => 'L’equipament és buit: tria almenys una peça.',
      no_catalogue: () =>
        'Aquest conjunt de mods encara no s’ha escanejat: no hi ha classes amb què comprovar-lo.',
    } as Record<string, (cls: string, found: string, kindIs: string) => string>,
    problemOther: (slot: string, cls: string) => `${slot}: ${cls}`,
    editKit: 'Edita',
    editKitFor: (name: string) => `Edita l’equipament ${name}`,
    newKit: 'Fes un equipament nou',
    newKitFor: 'Fes un equipament nou des de zero',
    sourceEditor: 'fet a l’editor',
  },
} as const;
